export const formatNumber = (num, numberObject) => {
  // console.log(num, numberObject);
  // console.log(numberObject);

  // Auto format number based on value, with configurable decimal places
  const autoFormatNumber = (incomingNumber, autoDecimalPlaces = 1) => {
    // const  number = Number(incomingNumber)
    let number = Number(incomingNumber);
    if (number === 0) return "0"; // Handle zero

    const isNegative = number < 0; // Check if the number is negative
    number = Math.abs(number);

    let formattedNumber;
    if (number >= 10000000) {
      formattedNumber = (number / 10000000).toFixed(autoDecimalPlaces) + "Cr"; // Format as Cr
    } else if (number >= 100000) {
      formattedNumber = (number / 100000).toFixed(autoDecimalPlaces) + "L"; // Format as L
    } else if (number >= 1000) {
      formattedNumber = (number / 1000).toFixed(autoDecimalPlaces) + "K"; // Format as K
    } else {
      formattedNumber = number.toFixed(autoDecimalPlaces).toLocaleString(); // Default for small numbers
    }

    return isNegative ? `-${formattedNumber}` : formattedNumber; // Add negative sign if needed
  };

  // Handle case where numberObject is undefined or empty
  if (!numberObject) {
    if (num === undefined) {
      return;
    } else {
      return autoFormatNumber(num); // Use auto format with default 1 decimal place
    }
  } else {
    // Destructure numberObject with default values
    const {
      decimalPlaces = 2, // For manual mode
      factor = 1,
      prefix = "",
      sufix = "",
      mode = "Auto",
      autoDecimalPlaces = 1, // New default value for auto mode
    } = numberObject;
    // console.log(numberObject);

    // If mode is "Auto", use auto format with custom or default decimal places
    if (mode === "Auto") {
      return autoFormatNumber(num, autoDecimalPlaces);
    } else {
      // Manual formatting mode
      // console.log("mode is manual");
      if (num === 0) return 0; // Handle zero for manual mode
      let formattedValue = (num / factor).toFixed(decimalPlaces);
      return `${prefix}${formattedValue}${sufix}`;
    }
  }
};
